import request from 'sb-request'
import { reducers, getState } from 'redux/core'
import { constants, localStorage } from 'common/helpers'


const selectItem    = reducers.view.makeupLandingPage.selectItem
const deselectItem  = reducers.view.makeupLandingPage.deselectItem

/**
 * Saves selected items to localStorage
 */
const saveSelectedItemsToStorage = () => {
  const { view: { makeupLandingPage: { selectedItems } } } = getState()

  localStorage.setItem(constants.localStorageNames.makeupLandingItems, selectedItems)
}

/**
 * Clear selected items from store and localStorage
 */
const clearSelectedItems = () => {
  localStorage.removeItem(constants.localStorageNames.makeupLandingItems)
  reducers.view.makeupLandingPage.clearSelectedItems()
}

/**
 * Clear selected items from makeup new style landing from store and localStorage
 */
const clearSelectedLandingItems = () => {
  localStorage.removeItem(constants.localStorageNames.makeupLandingNewStyleItems)
  reducers.view.makeupLandingPage.clearSelectedLandingItems()
}

const setSelectedItemsFromStorage = () => {
  const selectedItems         = localStorage.getItem(constants.localStorageNames.makeupLandingItems, [])
  const selectedLandingItems  = localStorage.getItem(constants.localStorageNames.makeupLandingNewStyleItems, [])

  reducers.view.makeupLandingPage.setSelectedItems(selectedItems)
  reducers.view.makeupLandingPage.setSelectedLandingItems(selectedLandingItems)
}

// todo @vkudla replace rest on graphql when added section param
const fetchProducts = () =>
  request.get('rest/shop/makeup?groupBy=section')
    .then(
      ({ items }) => {
        const itemsWithCategory = items.map((item) => ({
          ...item,
          category: item.section.replace('Makeup', '').toLowerCase(),
        }))

        const productsCount = itemsWithCategory.reduce((prev, curr) => [ ...prev, ...curr.items ], []).length

        reducers.models.products.setProducts(itemsWithCategory)
        reducers.models.products.setProductCount(productsCount)
      })


export default {
  selectItem,
  deselectItem,
  setSelectedItemsFromStorage,
  saveSelectedItemsToStorage,
  clearSelectedItems,
  clearSelectedLandingItems,
  fetchProducts,
}
